const HIDDEN_ISSUE_STATUSES = ["closed"]
// Dropped work stays linkable, but only when someone searches for it.
const SEARCH_ONLY_ISSUE_STATUSES = ["duplicate", "canceled", "cancelled"]

export function isSelectableIssue(
	issue: { status?: string | null; statusName?: string | null },
	searchQuery = "",
): boolean {
	if (!issue.status) return true
	if (HIDDEN_ISSUE_STATUSES.includes(issue.status)) return false
	const name = issue.statusName?.trim().toLowerCase()
	if (
		SEARCH_ONLY_ISSUE_STATUSES.includes(issue.status) ||
		(name && SEARCH_ONLY_ISSUE_STATUSES.includes(name))
	) {
		return !!searchQuery.trim()
	}
	return true
}
